import Raven from 'raven-js';
export const logSentryException = (error, options) => Raven.captureException(error, options);